import useUser from '@/hooks/useUser.js';
import routes from '@/routes.js';
import { useSelector } from 'react-redux';
import PlatformPrimaryNav from './PlatformPrimaryNav.jsx';
import PlatformSecondaryNav from './PlatformSecondaryNav.jsx';

const PlatformHeader = () => {
  const user = useUser();
  const activeRouteId = useSelector((state) => state.ui.activeRouteId);
  const activeRoute = routes.find((n) => n.id === activeRouteId) || {};

  const isLoggedIn = !!user?.jwt?.id;
  const useAppHeader = activeRoute.appHeader !== false && isLoggedIn;

  if (!useAppHeader) {
    return null;
  }

  return (
    <div className={'platform-header'}>
      <PlatformPrimaryNav />
      <PlatformSecondaryNav />
    </div>
  );
};

export default PlatformHeader;
